module.exports = __webpack_public_path__ + "static/media/cloud.28605668.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/misc/cloud.svg
// module id = 40
// module chunks = 0